// @dynamic-i18n-keys
// submissionDetailsHeader.moneyPromo.var.tier.CTA
// submissionDetailsHeader.moneyPromo.var.generic.CTA
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiData, ViewSubscriptionTabBiEvent } from '@wix/da-bi/pkg/events';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { PapiDeviation, PapiUser } from '@wix/da-papi-types';
import { Url, USER_PROFILE_SECTION_PATHS, sanitizeHref } from '@wix/da-url';
import s from './MoneyPromoButton.scss';

interface Props {
  user: PapiUser;
  moneyPromo?:
    | 'tier'
    | 'commission'
    | 'premium_gallery'
    | 'adoptable'
    | 'core'
    | 'generic';
  relevantDeviation?: PapiDeviation;
}

const MoneyPromoButton: React.FC<Props> = ({
  user,
  moneyPromo,
  relevantDeviation,
}) => {
  const { t } = useTranslation();

  let link: string | null = null;
  let ctaKey;

  if (moneyPromo === 'tier') {
    link = Url.userSubscriptionsPath({
      username: user.username,
    });
    ctaKey = `submissionDetailsHeader.moneyPromo.var.tier.CTA`;
  } else {
    link = Url.userLink(user.username, USER_PROFILE_SECTION_PATHS.SHOP);
    ctaKey = `submissionDetailsHeader.moneyPromo.var.generic.CTA`;
  }

  return (
    <BiLink
      className={s['root']}
      href={sanitizeHref(link)}
      biData={
        relevantDeviation
          ? BiData<ViewSubscriptionTabBiEvent>({
              evid: 547,
              typeid: relevantDeviation.typeId,
              itemid: relevantDeviation.deviationId,
              referral_info: ReferralType.ART_STAGE_PROMOTION,
            })
          : undefined
      }
    >
      {t(ctaKey)}
    </BiLink>
  );
};
MoneyPromoButton.displayName = 'MoneyPromoButton';

export default MoneyPromoButton;
